<template>
  <footer class="calm-footer">
    <div class="calm-footer__copy">
      © {{ year }}
      <a :href="appUrl" class="calm-footer__link" target="_blank">{{ appName }}</a>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      appName : process.env.VUE_APP_TITLE,
      appUrl : process.env.VUE_APP_URL

    };
  }
};
</script>
<style lang="scss" scoped>
/* ── Slim Calm footer ──
   Only rendered inside the Calm DashboardLayout; tokens (--c-*) come from
   .calm-layout. Namespaced `calm-footer*` so no other layout is affected. */
.calm-footer {
  padding: 14px 32px;
  background: var(--c-surface);
  border-top: 1px solid var(--c-border);
  font-family: var(--c-font);
}
.calm-footer__copy {
  font-size: 12.5px;
  color: var(--c-text-mute);
}
.calm-footer__link {
  margin-left: 4px;
  font-weight: 600;
  color: var(--c-text-soft);
  text-decoration: none;
}
.calm-footer__link:hover {
  color: var(--c-blue);
}
</style>
